import * as React from 'react';
import { getWebsiteProviderDisplay, WebsiteProviderSource } from '../../../../utils/websiteProvider';
import { Pill } from '../../../../web/components-v2/Pill';

export const WebsiteProviderPill: React.FC<{ websites: WebsiteProviderSource | undefined }> = ({ websites }) => {
	const display = getWebsiteProviderDisplay(websites);

	return <Pill variant='tag' color={display.color} size='small' label={display.label} />;
};
